export enum PublicationsButtons {
  REFRESH_PUBLICATION = 'refresh-publication',
  BLACKLIST = 'blacklist',
  DISABLE_CATALOG = 'disable-catalog',
}
